<template>
  <div ref="sidebar">
    <div class="p-2 flex items-center h-14 text-blue-dark bg-blue-darkest font-semibold text-xl px-4">
      <router-link
        to="/"
        class="no-underline text-blue-dark"
      >
        <h1 class="text-2xl tracking-wide uppercase">
          Eros
        </h1>
      </router-link>
    </div>
    <LoggedUserSection></LoggedUserSection>
    <menu-item title="Artigos">
      <product-SVG slot="image" />
      <menu-item-link to="/products">Todos</menu-item-link>
      <!-- <menu-item-link to="/inventory">Inventário</menu-item-link> -->
      <menu-item-link to="/inventory-pages">Folhas Inventário</menu-item-link>
      <menu-item-link to="/products/movement">Criar Movimento</menu-item-link>
    </menu-item>

    <menu-item title="Pedidos">
      <order-SVG slot="image" />
      <menu-item-link to="/orders">Todos</menu-item-link>
      <menu-item-link to="/orders?isongoing=1">Em Curso</menu-item-link>
      <menu-item-link to="/orders?missing=1">Art. em Falta</menu-item-link>
    </menu-item>
    <menu-item title="Compras">
      <supply-order-SVG slot="image" />
      <menu-item-link to="/supply-orders">Recebidas</menu-item-link>
      <menu-item-link to="/supply-orders?ongoing=true">Em Curso</menu-item-link>
    </menu-item>
    <menu-item title="Fornecedores">
      <supplier-icon slot="image"></supplier-icon>
      <menu-item-link to="/suppliers">Todos</menu-item-link>
    </menu-item>
    <ul class="list-reset mb-2 text-xs">
      <li class="text-xs text-blue-dark pl-4 pr-2 py-2 cursor-pointer hover:bg-blue-light">
        <router-link
          to="/stocks"
          class="flex items-center no-underline font-normal"
        >
          <StocksSVG />
          <span class="text-sm mb-0 ml-2 uppercase text-blue-dark no-underline hover:text-grey hover:no-underline font-normal mr-auto">
            Stocks
          </span>
        </router-link>
      </li>
    </ul>
    <menu-item title="Guias">
      <transport-label-SVG slot="image"></transport-label-SVG>
      <menu-item-link to="/transport-label-list">Todas</menu-item-link>
      <menu-item-link to="/transport-label/new">Nova Guia</menu-item-link>
    </menu-item>

    <menu-item title="Tarefas">
      <tasks-SVG slot="image"></tasks-SVG>
      <menu-item-link to="/tasks">Todas</menu-item-link>
      <menu-item-link to="/tasks?open">Em Aberto</menu-item-link>
    </menu-item>
  </div>
</template>

<script>
import LoggedUserSection from "./sidemenu/LoggedUserSection.vue";
import MenuItem from "./sidemenu/MenuItem.vue";
import MenuItemLink from "./sidemenu/MenuItemLink.vue";
import ProductSVG from "./sidemenu/svgs/ProductSVG.vue";
import OrderSVG from "./sidemenu/svgs/OrderSVG.vue";
import SupplyOrderSVG from "./sidemenu/svgs/SupplyOrderSVG.vue";
import TasksSVG from "./sidemenu/svgs/TasksSVG.vue";
import StocksSVG from "./sidemenu/svgs/StocksSVG.vue";
import TransportLabelSVG from "./sidemenu/svgs/TransportLabelSVG.vue";
import SupplierIcon from "../Icons/SupplierIcon.vue";
import { mapState } from "vuex";
import Hammer from "hammerjs";
import _ from "lodash";

export default {
  components: {
    LoggedUserSection,
    MenuItem,
    MenuItemLink,
    ProductSVG,
    OrderSVG,
    SupplyOrderSVG,
    TasksSVG,
    TransportLabelSVG,
    SupplierIcon,
    StocksSVG
  },
  mounted() {
    let hammer = new Hammer(this.$refs.sidebar);
    hammer.on("panleft", _.debounce(this.handleHideOnPanleft, 300));
  },
  methods: {
    handleHideOnPanleft(ev) {
      console.log("debounced", ev.type);
      this.$store.commit("toggleShowMenu");
    }
  },
  computed: mapState({
    showMenu: state => state.showMenu
  }),
  data() {
    return {
      showProductLinks: false,
      showOrderLinks: false,
      showLabelLinks: false,
      showSupplyOrderLinks: false,
      showTaskLinks: false
    };
  }
};
</script>

<style>
.sidebar {
  transition: display 1s;
}
/* .product-icon {
    fill: none;
    stroke: white;
  } */
</style>


// WEBPACK FOOTER //
// SideMenu.vue?31a9d00f